import styled from 'styled-components';
import Tabs from '../../../Tabs';

const StyledExpensesTabsContainer = styled.div`
  display: flex;
  min-height: calc(100vh - 66px);
  overflow-x: hidden;
  padding: 24px;
  position: relative;
  transition: .3s ease-in-out;

  .expense-details-panel {
    position: fixed !important;
    top: 90px !important;
    min-height: calc(100vh - 66px - 42px);
    padding-right: 24px;

    .ant-tabs-content-holder {
      min-height: unset;
      padding: 0;

      .ant-tabs-content {
        max-height: calc(100vh - 66px - 24px * 2 - 42px);
        overflow: auto;
        padding: 16px 16px 0 16px;

        .expense-details-tab {
          footer {
            margin-left: -16px;
            width: calc(100% + 16px * 2);
          }
        }
      }
    }
  }

  .expense-type {
    align-items: center;
    display: flex;

    svg {
      height: 24px;
      width: 24px;

      path {
        fill: ${props => props.theme.colors.neutral_6};
      }
    }
  }
`;

const StyledExpensesTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    padding: 24px 0;
  }
`;


export {
  StyledExpensesTabs,
  StyledExpensesTabsContainer,
}
